/**
 * Popup Action Handler
 * Responsible for handling business logic triggered by popup interactions
 */
(function () {
  // Check necessary dependencies
  const dependencies = ["PopupStore", "PopupHandlers"];

  for (const dep of dependencies) {
    if (!window._erj_[dep]) {
      console.error(
        `${dep} is not available, action handler module initialization failed`
      );
      return;
    }
  }

  const _debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  // Get popup type
  const _getPopupType = (element) => {
    const overlay = element.closest(".erj-popup-overlay, [data-erj-popup-id]");
    return overlay ? overlay.getAttribute("data-erj-popup-type") : null;
  };

  // Get popup ID
  const _getPopupId = (element) => {
    const overlay = element.closest(".erj-popup-overlay, [data-erj-popup-id]");
    return overlay
      ? overlay.id || overlay.getAttribute("data-erj-popup-id")
      : null;
  };

  // Set up event delegation listeners
  const _setupEventDelegation = () => {
    // Handle submit action
    // Handle submit button click
    document.addEventListener("click", (event) => {
      if (!event.target.matches("[data-erj-popup-submit]")) return;

      event.preventDefault();

      const popupId = _getPopupId(event.target);
      const popupType = _getPopupType(event.target);

      if (popupId && popupType && window._erj_.PopupHandlers[popupType]) {
        window._erj_.PopupHandlers[popupType].handleSubmit(popupId);
      }
    });

    // Handle form submission events
    document.addEventListener("submit", (event) => {
      const form = event.target;
      if (!form) return;

      event.preventDefault();

      const popupId = _getPopupId(form);
      const popupType = _getPopupType(form);

      if (popupId && popupType && window._erj_.PopupHandlers[popupType]) {
        window._erj_.PopupHandlers[popupType].handleSubmit(popupId);
      }
    });

    // Handle input events - using debounce
    document.addEventListener(
      "input",
      _debounce((event) => {
        if (!event.target.matches("[data-erj-popup-input]")) return;

        const popupId = _getPopupId(event.target);
        const popupType = _getPopupType(event.target);

        if (popupId && popupType && window._erj_.PopupHandlers[popupType]) {
          window._erj_.PopupHandlers[popupType].handleInput(
            popupId,
            event.target
          );
        }
      }, 300)
    );

    // Handle close popup
    document.addEventListener("click", (event) => {
      if (!event.target.matches(".erj-popup-close")) return;

      const popupId = _getPopupId(event.target);
      const popupType = _getPopupType(event.target);

      if (popupId && popupType && window._erj_.PopupHandlers[popupType]) {
        window._erj_.PopupHandlers[popupType].handleClose(popupId);
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const activePopupId = window._erj_.PopupQueue.getActivePopupId();
        if (!activePopupId) return;

        window._erj_.PopupQueue.closePopup(activePopupId, {
          reason: "user_action:click_escape_key",
        });
      }
    });
  };

  // Initialize all popup states
  const _initAllPopupsHandler = () => {
    const popups = document.querySelectorAll(
      ".erj-popup-overlay[data-erj-popup-id]"
    );

    popups.forEach(async (popup) => {
      const popupId = popup.getAttribute("data-erj-popup-id");
      const popupType = popup.getAttribute("data-erj-popup-type");

      // Initialize state based on type
      switch (popupType) {
        case "newsletter":
        // const isLotteryWheelEnabled = await window._erj_?.getFeatureValue?.("lottery-wheel") || false;
        window._erj_.PopupHandlers.newsletter.init(popupId);
        break;
        default:
          break;
      }
    });
  };

  // Public API
  const PopupActions = {
    /**
     * Initialize popup action handler
     */
    init() {
      _setupEventDelegation();
      _initAllPopupsHandler();
    },
  };

  // Export to global object
  window._erj_ = window._erj_ || {};
  window._erj_.PopupActions = PopupActions;

  // Initialize after DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    PopupActions.init();
  });
})();
